module.exports = __webpack_public_path__ + "static/media/bird.a6d47abc.gif";